// const NextI18Next = require('next-i18next').default;
// const { localeSubpaths } = require('next/config').default().publicRuntimeConfig;
// const path = require('path');

// module.exports = new NextI18Next({
//     browserLanguageDetection: true,
//     serverLanguageDetection: true,
//     defaultLanguage: 'en',
//     fallbackLng: 'en',
//     otherLanguages: Object.values(localeSubpaths),
//     fallbackNS: 'common',
//     defaultNS: 'common',
//     ns: 'common',
//     localeSubpaths,
//     localePath: path.resolve('./public/static/locales')
//     // backend: {
//     //     projectId: locizeProjectId,
//     //     apiKey: locizeApiKey,
//     //     version: locizeVersion || 'latest',
//     //     referenceLng: 'en',
//     //     allowedAddOrUpdateHosts: ['localhost', 'apsyhost']
//     // }
// });
import useTranslation from 'next-translate/useTranslation';

export { useTranslation };
